import { useState, useEffect, useCallback } from 'react';
import { apiClient } from '../utils/api';

export function useTxRxRetriesData(mac, interval, customRange) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchData = useCallback(async () => {
        if (!mac) {
            setData(null);
            setError(null);
            return;
        }

        if (interval === 'custom' && (!customRange?.start || !customRange?.end)) {
            setData(null);
            setError(null);
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const extraParams = {};
            if (interval === 'custom') {
                extraParams.dt_start = customRange.start;
                extraParams.dt_end = customRange.end;
            }

            const response = await apiClient.getTxRxRetriesData(mac, interval, extraParams);
            setData(response);
        } catch (err) {
            console.error('Failed to fetch tx/rx retries data:', err);
            setError(err?.message || 'Failed to fetch tx/rx retries data');
            setData(null);
        } finally {
            setLoading(false);
        }
    }, [mac, interval, customRange?.start, customRange?.end]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return {
        data,
        loading,
        error,
        refresh: fetchData
    };
}
